import { Stack, Typography } from "@mui/material";
import { StepBarSection, StepDonutSection } from "../usersApiMapping";
import UsersStepBarSection from "./UsersStepBarSection";
import UsersStepDonutSection from "./UsersStepDonutSection";

interface UsersStepSectionsProps {
  step1Section: StepBarSection;
  step2Section: StepBarSection;
  step3Section: StepBarSection;
  step4Section: StepBarSection;
  step5Section: StepDonutSection;
  step6Section: StepBarSection;
  step7Section: StepBarSection;
}

export default function UsersStepSections({
  step1Section,
  step2Section,
  step3Section,
  step4Section,
  step5Section,
  step6Section,
  step7Section,
}: UsersStepSectionsProps) {
  const sections = [
    step1Section,
    step2Section,
    step3Section,
    step4Section,
    step5Section,
    step6Section,
    step7Section,
  ];

  return (
    <Stack spacing={4}>
      {sections.map((section) => (
        <Stack key={section.title} spacing={1.75}>
          <Typography sx={{ fontSize: 17, fontWeight: 500, color: "#1a1a1a" }}>
            {section.title}
          </Typography>
          {section.kind === "bar" ? (
            <UsersStepBarSection section={section} />
          ) : (
            <UsersStepDonutSection section={section} />
          )}
        </Stack>
      ))}
    </Stack>
  );
}
